import React from 'react';
import i18n from 'i18next';

export default class RouteBoundary extends React.Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() {
    return this.state.failed ? <div role="alert"><p>{i18n.t('screenLoadFailed')}</p>
      <button onClick={() => window.location.reload()}>{i18n.t('retryAction')}</button></div> : this.props.children;
  }
}
